<div class="h-100 tallint-table type-2" tabindex="1" #nativeTableCode [id]="this.random_id"
  [ngClass]="{'pb-2':!pagination_type}" *ngIf="!hide_table">
  <div title="Export" class="pointer" style="
    z-index: 1000;
    /* top: 0px; */
    left: 0px;
    position: fixed;
    background: #2471b0;
    display: inline-block;
    width: 23px;
    text-align: center;
">
    <!-- <div>
            <ngc-float-button style="z-index: 999;" icon="add" direction="{{'bottom'}}">
                <ngc-float-item-button icon="person_add" content="float item 1"> </ngc-float-item-button>
                <ngc-float-item-button icon="gps_fixed" content="float item 2"></ngc-float-item-button>
                <ngc-float-item-button icon="mode_edit" content="float item 3"></ngc-float-item-button>
            </ngc-float-button>
        </div> -->
    <div *ngIf="false" class="text-center" (click)="exportDataToExcel()" style="box-shadow: 0 0px 2px gainsboro;">
      <i class="fa fa-file-excel-o" style="color: white;"></i>
    </div>
    <div *ngIf="grid_configuration" class="text-center" style="box-shadow: 0 0px 2px gainsboro;"
      (click)="openColumnDetails()">
      <i title="Column Details" class="fa fa-cog" style="color: white;"></i>
    </div>
  </div>


  <!-- <cdk-virtual-scroll-viewport #virtual_scroll class="h-100 "
    (scrolledIndexChange)=" (!pagination_type || pagination_type==1)? getNextBatch($event):pagination2Scrolling($event)"
    [itemSize]="item_size"> -->
  <table class="table skeleton" *ngIf="fetching_entries">
    <tbody>
      <tr *ngFor="let a of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]; let i=index;" style="width: 100%;">
        <th *ngFor="let bs of [1,2,3,4,5,6,7,8,9,10]; let j=index;" class="skeleton-th">
          <div [style.width]="random_width.length &&random_width[i][j]" class="horizontal-bar"></div>
        </th>
      </tr>
    </tbody>
  </table>


  <!--[style.height.px]="table_height"-->

  <!--[style.height.px]="table_height"-->
  <!-- [style.height.px]="nested?null:item_size*total_count" -->
  <!-- <span><i class=" fa fa-upload " style="z-index: 100; top: 0px; position: absolute;" (click)="exportDataToExcel()" *ngIf="export"></i></span> -->

  <table class="table table-striped table-hover m-0 tal-table">
    <thead>
      <tr style="background: none;
      background-color: #f3f3f3;" *ngIf="tallint_table_columns && tallint_table_columns.length>0">
        <th class="tallint-th" style="position: sticky; top: 0; background: #f3f3f3 !important;" *ngIf="nested">
          <i class="fa fa-plus-square"></i>
        </th>

        <th class="p-0 pl-2 pr-2 text-center " *ngIf="multi_select" [style.top]="calclateTop()"
          style="position: sticky;width: 35px; background: #f3f3f3 !important;">
          <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-square-o pointer mt-1" type="checkbox"
            (click)="selectAll(true)" *ngIf="!select_all ||  selected_entries.length ==0"></i>
          <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-check-square-o pointer mt-1"
            (click)="selectAll(false)" *ngIf="select_all && selected_entries.length >0"></i>
        </th>

        <!-- <th class="p-0 pl-2 pr-2 text-center " *ngIf="enable_action" [style.top]="calclateTop()"
          style="position: sticky;width: 35px;padding-top:0 !important;padding-bottom:0 !important; top: 0; background: #f3f3f3 !important;">
          Action
        </th> -->

        <th class="tallint-th pointer text-center" *ngIf="enable_action" [style.top]="calclateTop()"
          style="position: sticky;">
          <div>
            Action
          </div>
        </th>

        <th style="width: 30px;" class="tallint-th pointer" *ngIf="edit" [style.top]="calclateTop()"
          style="position: sticky;">
          <div style="width: 30px;">
            Edit
          </div>
        </th>

        <ng-container *ngFor="let column of tallint_table_columns; let index=index;">
          <!--(mousedown)="resizeTable($event,column)"-->
          <th
            [title]=" column.dataType =='template' ||column.dataType =='innerHTML' || column.dataType =='file'?(column.title |InnerHTMLToText) : column.title"
            *ngIf="column.visible" class="tallint-th" (dblclick)="sortColumn(column)"
            [ngStyle]=" column.style ? (column.style |checkStyle : column:column :1):null "
            [id]="random_id + ''+ column.columnId" [ngClass]="{'text-right right-me-lelo':column.dataType=='int'}"
            [style.top]="calclateTop()" style="position: sticky;">
            <div class="tallint-data-grid"
              style="cursor: column-resize !important; border-right: 3px solid transparent; display: flex;align-items: center;"
              [ngStyle]="{'width':column.width > 10 ? column.width+'px':'100px'}"
              [ngClass]="{'text-right right-me-lelo':column.dataType=='int'}">

              <!-- <a class="from-label-code" *ngIf="(column.module_code&&column.sub_module_code&&column.form_code&&column.label_code);else coltitle"> {{'1001_10004_1200010_1002' | translate }}</a> -->
              <span class=" d-inline-block actual-data-header" style="width: 100%;overflow: hidden;"
                [ngClass]="{'text-right right-me-lelo':column.dataType=='int'}">
                <span *ngIf="column.title; else label_code">
                  <span class="margin column-header" [ngClass]="{'text-right right-me-lelo':column.dataType=='int'}">
                    <span class="column-title pointer"
                      [innerHTML]='column.title | HTMLFormatter | safeHTMLPipe :"html"'>
                    </span>
                  </span>
                </span>
                <ng-template #label_code>

                  <span class="margin">
                    <span [innerHTML]='(column.label_code | translate) | HTMLFormatter | safeHTMLPipe :"html"'></span>
                  </span>
                  <!--{{column.label_code | translate}}-->
                </ng-template>
              </span>
              <span>
                <!-- <i class="fa fa-filter d-none pointer sort-icon"
                  [ngClass]="{'show-filter':column.dataType !='template' &&column.dataType !='innerHTML' && column.dataType !='file'}"
                  (click)="sortColumn(column)"
                  *ngIf="!column.sort && enable_sort &&column.sort !=false && column.sort !=true && !this.pressed  "></i> -->
                <i class="fa fa-filter pointer filter-icon" (click)="sortColumn(column)"
                  *ngIf="enable_sort &&!column.sort &&column.sort != false "></i>
                <i class="fa fa-arrow-up pointer sort-icon" (click)="sortColumn(column)"
                  *ngIf="enable_sort &&column.sort == true"></i>
                <i class="fa fa-arrow-down pointer sort-icon" (click)="sortColumn(column)"
                  *ngIf="enable_sort &&column.sort == false"></i>
              </span>

              <!-- <ng-template class="from-title">{{column.title}}</ng-template> -->
            </div>
          </th>

        </ng-container>

        <!-- <th class="tallint-th pointer" style="min-width: 80px;  position:sticky;" (click)="exportDataToExcel()" *ngIf="export">Export</th> -->
      </tr>
    </thead>
    <tr *ngIf="display_filter">
      <td *ngIf="multi_select">
        <div class="input-group border-radius-0 border-0"></div>
      </td>
      <td class="tallint-td p-0 bg-white" *ngIf="edit">
        <div class="input-group border-radius-0 border-0">
        </div>
      </td>
      <ng-container *ngFor="let column of tallint_table_columns; let index=index;">
        <td *ngIf="column.visible" class="tallint-td p-0">
          <div class="input-group border-radius-0 border-0">
            <input (keyup.enter)="filterEntries(false)" type="text"
              class="form-control border-radius-0 border-0 tallint-table-search" [(ngModel)]="filter[index].value">
            <div (click)="filterEntries(false)" class="input-group-append border-radius-0 border-0 cursor-pointer">
              <span class="input-group-text border-radius-0 border-0 bg-white">
                <i class="fa fa-search"></i>
              </span>
            </div>
          </div>
        </td>
      </ng-container>

    </tr>

    <!-- <tr style="position: absolute;" [ngStyle]="{'top': (footer_position)+'px'}">
        <td *ngFor="let column of tallint_table_columns; let index=index;">
          <div [title]="column.title" *ngIf="column.visible != false" class="tallint-th"
            (click)="sortColumn(column)" [ngClass]="{'text-right':column.dataType=='int'}">
            <div
              style="cursor: col-resize !important; border-right: 3px solid transparent; z-index: 1000;display: inline-block;"
              (mousedown)="resizeTable($event,column)" [ngStyle]="{'width':column.width?column.width+'px':'100px'}"
              [ngClass]="{'text-right':column.dataType=='int'}">
              <i class="fa fa-arrow-up" *ngIf="column.sort == true"></i>
              <i class="fa fa-arrow-down" *ngIf="column.sort == false"></i>

              <span class="pointer d-inline-block" style="width: 90%;overflow: hidden;">
                <span *ngIf="column.title; else label_code">
                  <span class="margin">
                    <span [innerHTML]='column.title'>
                    </span>
                  </span>
                </span>
                <ng-template #label_code>
                  <span class="margin">
                    <span [innerHTML]='column.label_code | translate'></span>
                  </span>
                </ng-template>
              </span>
            </div>
          </div>
        </td>
      </tr> -->
    <ng-container *ngFor="let row of table_records;let i=index;">
      <ng-container *ngTemplateOutlet="tr; context: {row: row,index:i}"></ng-container>
      <ng-container *ngIf="nested_pattern==1">
        <ng-container *ngFor="let sub_row of row.records">
          <tr table-row [nested]="nested" [padding_exp]="10" *ngIf="row.nested_flag"
            [rowSelected]="rowSelected.bind(this)" [row]="sub_row" [tallint_table_columns]="tallint_table_columns"
            [multi_select]="multi_select" [edit]="edit" [cellClick]="cellClick.bind(this)">
          </tr>
          <ng-container *ngFor="let sub_row_1 of sub_row.records">
            <tr table-row [nested]="nested" [padding_exp]="15" *ngIf="sub_row && sub_row.nested_flag && row.nested_flag"
              [rowSelected]="rowSelected.bind(this)" [row]="sub_row_1" [tallint_table_columns]="tallint_table_columns"
              [multi_select]="multi_select" [edit]="edit" [cellClick]="cellClick.bind(this)">
            </tr>
            <ng-container *ngFor="let sub_row_2 of sub_row_1.records">
              <tr table-row [nested]="nested" [padding_exp]="20"
                *ngIf="sub_row_1 && sub_row_1.nested_flag && sub_row.nested_flag && row.nested_flag"
                [rowSelected]="rowSelected.bind(this)" [row]="sub_row_2" [tallint_table_columns]="tallint_table_columns"
                [multi_select]="multi_select" [edit]="edit" [cellClick]="cellClick.bind(this)">
              </tr>
              <ng-container *ngFor="let sub_row_3 of sub_row_2.records">
                <tr table-row [nested]="nested" [padding_exp]="25"
                  *ngIf="sub_row_2 && sub_row_2.nested_flag && sub_row_1.nested_flag && sub_row.nested_flag && row.nested_flag"
                  [rowSelected]="rowSelected.bind(this)" [row]="sub_row_3"
                  [tallint_table_columns]="tallint_table_columns" [multi_select]="multi_select" [edit]="edit"
                  [cellClick]="cellClick.bind(this)">
                </tr>
                <ng-container *ngFor="let sub_row_4 of sub_row_3.records">
                  <tr table-row [nested]="nested" [padding_exp]="30"
                    *ngIf="sub_row_3 && sub_row_3.nested_flag && sub_row_2.nested_flag && sub_row_1.nested_flag && sub_row.nested_flag && row.nested_flag"
                    [rowSelected]="rowSelected.bind(this)" [row]="sub_row_4"
                    [tallint_table_columns]="tallint_table_columns" [multi_select]="multi_select" [edit]="edit"
                    [cellClick]="cellClick.bind(this)">
                  </tr>
                  <ng-container *ngFor="let sub_row_5 of sub_row_4.records">
                    <tr table-row [nested]="nested" [padding_exp]="35"
                      *ngIf="sub_row_4 && sub_row_4.nested_flag  && sub_row_3.nested_flag && sub_row_2.nested_flag && sub_row_1.nested_flag && sub_row.nested_flag && row.nested_flag"
                      [rowSelected]="rowSelected.bind(this)" [row]="sub_row_5"
                      [tallint_table_columns]="tallint_table_columns" [multi_select]="multi_select" [edit]="edit"
                      [cellClick]="cellClick.bind(this)">
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="nested_pattern==2 && row.table_object">
        <ng-container *ngTemplateOutlet="nested_tr; context: {row: row}"></ng-container>
      </ng-container>



    </ng-container>
  </table>
  <div class="text-center no-records-found" *ngIf="!fetching_entries && !(table_records && table_records.length)">
    {{no_data_message?(no_data_message |translate):'No data found!'}}
  </div>
  <!-- </cdk-virtual-scroll-viewport> -->
  <div style="position: absolute; top:0; left:0; width:100%; height:100%; pointer-events:none"></div>
  <!-- <div class="row">
    <div class="col-md-3  align-self-center">
      <icr-select [form_group]="limit_form" [form_control]="'limit'" [title_property]="'title'"
        (selected_obj)="start_page=1;getNextBatch(1)" [id_property]="'code'" [options]="limit_list" [design_pattern]="2"
        [placeholder]="' < - - Select - - > '">
      </icr-select>
    </div>

    <div class="col-md-9">

    </div>

  </div> -->
  <div class="pointer mt-3"
    *ngIf="pagination_type==2 && this.table_records && table_records.length && total_count>limit_form.value.limit"
    style=" display:inline-block">
    <span class="page-link" style="display: inline-block; font-size: 12px;"
      [ngClass]="{'active':current_limit == i.code}" *ngFor="let i of limit_list;let index = index"
      (click)="getNextBatch(null,index)">
      {{i.title}}
    </span>
  </div>
  <ngb-pagination *ngIf="pagination_type==2 && total_count && total_count>limit_form.value.limit "
    class=" float-right mt-3" [collectionSize]="total_count" [(page)]="start_page" [maxSize]="5" [rotate]="true"
    (pageChange)="getNextBatch($event)" [pageSize]="limit_form.value.limit || 40">
  </ngb-pagination>



  <ng-template #tr let-display_row="row" let-i="index">
    <tr [ngStyle]=" tallint_table_columns |checkStyleRow : display_row" [id]="random_id_row"
      [ngClass]="{'selectedRow':selectedRowIndex==i}">
      <td class="tallint-td pointer" *ngIf="nested==true" (click)="cellClick('display', display_row)">
        <i class="fa" *ngIf="display_row.child==1"
          [ngClass]="{'fa-minus-square': display_row.nested_flag ,'fa-plus-square': !display_row.nested_flag}">
        </i>
      </td>
      <td class="p-0 pl-2 pr-2 text-center" style="padding:0 !important;" *ngIf="multi_select">
        <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-square-o pointer mt-1" type="checkbox"
          (click)="rowSelected(display_row)" *ngIf="!display_row['row_selected']"></i>
        <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-check-square-o pointer mt-1"
          (click)="rowSelected(display_row)" *ngIf="display_row['row_selected']"></i>
      </td>
      <td class="p-0 pl-2 pr-2 text-center  " style="padding:0 !important;" *ngIf="enable_action">

        <ng-container *ngIf="primary_actions && this.primary_actions.length">
          <ng-container *ngFor="let btn of this.primary_actions">
            <ng-container *ngIf="btn.condition | DynamicConditionEval : display_row ">
              <ng-container *ngIf="!btn.inner_html_icon">
                <i style="color:#196ca5 !important;font-size:16px;" [title]="btn.title | translate"
                  (click)="triggerCellClick(btn.func,display_row,null,btn,$event)"
                  class="fa {{btn.icon}} pointer mt-1 mx-2 pointer"></i>
              </ng-container>
              <ng-container *ngIf="btn.inner_html_icon">
                <span class="text-center mt-1 mx-2 pointer" style="font-size: 16px;"
                  (click)="triggerCellClick(btn.func,display_row,null,btn,$event)" [matMenuTriggerFor]="menu8"
                  [innerHtml]="(btn.property | DynamicConditionEval :display_row : 2 )| safeHTMLPipe:'html'"></span>
                <mat-menu #menu8="matMenu" class="customize">
                  <button mat-menu-item *ngFor="let item of btn.dropdown_data.list; let i=index"
                    (click)="(btn.menuCallback)(item)" [innerHtml]="item.icon| safeHTMLPipe:'html'">
                  </button>
                </mat-menu>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-ellipsis-v pointer mt-1 mx-2 mr-3"
          [matMenuTriggerFor]="menu" *ngIf="secondary_actions && secondary_actions.length"></i>
      </td>
      <mat-menu #menu="matMenu">
        <ng-container *ngFor="let action of secondary_actions">
          <button mat-menu-item style="outline: none !important;"
            *ngIf="action.condition | DynamicConditionEval : display_row "
            (click)="triggerCellClick(action.func,display_row,null,action,$event)">
            <i style="font-size: 13px;" class="mr-1" [ngClass]="action.icon" *ngIf="action.show_icon"></i>
            <span> {{action.title | translate}} </span>
          </button>
        </ng-container>


      </mat-menu>

      <td class="tallint-td my-auto" (click)="triggerCellClick('edit', display_row)" *ngIf="edit">
        <div class="text-center" style="width: 30px;">
          <i class="fa fa-pencil pointer"></i>
        </div>
      </td>
      <!--'font-weight-bold': nested==true && display_row.child==0-->
      <ng-container *ngFor="let column of tallint_table_columns; let index=index;">
        <td *ngIf="column.visible != false" [id]="this.timestamp + random_id+ 'tallite-td'+ i + index"
          (click)="tableCellClicked(i,index)"
          [class]="column.function_name && column.function_name!=''?'pointer table-link tallint-td':'tallint-td'"
          [ngStyle]=" column.style |checkStyle : display_row:column"
          [ngClass]="{'selectedCol':selectedRowIndex==i && selectedColIndex==index}">
          <div
            [ngStyle]="{'width': column.width > 10 ? column.width+'px' : '100px','color': (column.function_name && column.function_name!='') ? '#0056b3' : ''}"
            class="column-header tallint-data-grid " [ngClass]="{'text-right right-me-lelo':column.dataType=='int'}"
            [class]="column.cell_class" style="border-right: 3px solid transparent;" [attr.data-th]="column.title">
            <ng-container *ngIf="!(column.conditions && column.conditions.length)">
              <ng-container *ngIf="!column.cell_template">
                <ng-container *ngIf="column.dataType =='string';else checkDate">
                  <span class="margin"
                    [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])">
                    <span (click)="triggerCellClick(column.function_name, display_row, column,null,$event)">
                      {{(display_row.processed_data ? display_row.processed_data[column.property] :
                      display_row[column.property])}}
                    </span>
                    <!-- [innerHTML]='(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])| HTMLFormatter' -->
                  </span>
                  <span class="float-right" [innerHTML]="column.quick ||  quickTemplate | safeHTMLPipe :'html'"
                    (click)="triggerCellClick(column.function_name, display_row, column,null,$event,1)"
                    *ngIf="column.quick && column.function_name"> <i class="fa fa-tasks"></i> </span>
                </ng-container>
                <ng-template #checkDate>
                  <ng-container *ngIf="column.dataType ==='date';else checkDateTime">
                    <span class="column-title"
                      (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                      [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])  | LocalDatePipe">
                      {{(display_row.processed_data ? display_row.processed_data[column.property] :
                      display_row[column.property])| LocalDatePipe}}
                    </span>
                  </ng-container>
                </ng-template>
                <ng-template #checkDateTime>
                  <ng-container *ngIf="column.dataType ==='datetime';else checkTime">
                    <span class="column-title"
                      (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                      [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])  | LocalDateTimePipe">
                      {{(display_row.processed_data ? display_row.processed_data[column.property] :
                      display_row[column.property]) | LocalDateTimePipe}}
                    </span>
                  </ng-container>
                </ng-template>
                <ng-template #checkTime>
                  <ng-container class="column-title" *ngIf="column.dataType ==='time';else checknvarchar;">
                    <span (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                      [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])  | LocalDateTimePipe">
                      {{(display_row.processed_data ? display_row.processed_data[column.property] :
                      display_row[column.property]) | UtcToLocalTime | date: 'h:mm a'}}
                    </span>
                  </ng-container>
                </ng-template>

                <ng-template #checknvarchar>
                  <ng-container *ngIf="column.dataType =='nvarchar';else checkvarbinary;">
                    <span class="margin column-header">
                      <span class="column-title"
                        (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                        [innerHTML]='(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])| HTMLFormatter | safeHTMLPipe :"html"'>
                      </span>
                    </span>
                  </ng-container>
                </ng-template>

                <ng-template #checkvarbinary>
                  <ng-container *ngIf="column.dataType =='varbinary';else checkHtmlTemplate;">
                    <span class="column-title"
                      (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                      [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property]) | DynamicFilesTitlePipe">
                      {{(display_row.processed_data ? display_row.processed_data[column.property] :
                      display_row[column.property]) | DynamicFilesTitlePipe}}
                    </span>
                  </ng-container>
                </ng-template>
                <ng-template #checkHtmlTemplate>
                  <ng-container *ngIf="column.dataType =='template';else innerHTMLs;">
                    <div class="margin"
                      [innerHTML]="((column.style |checkTemplate : display_row:column)| HTMLFormatter)|safeHTMLPipe :'html'">
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #innerHTMLs>
                  <ng-container *ngIf="column.dataType =='innerHTML';else noDataType">
                    <div class="margin">
                      <ng-container
                        *ngIf="column.uiConfig && column.uiConfig.shortcuts &&column.uiConfig.shortcuts.length;else noUIConfig">
                        <ng-container *ngFor="let item of column.uiConfig.shortcuts">
                          <span class="mx-2 shortcut" [title]="item.title"
                            (click)="checkListItemClicked(display_row,item,column,$event)"
                            *ngIf="item.conditions | CheckGridConditions : display_row">
                            <i *ngIf="item.faIcon" [class]="item.faIcon"></i>
                            <img *ngIf="item.attachment &&item.attachment.length "
                              [src]="'https://storage.googleapis.com/ezeone/icanrefer/' + item.attachment[0].cdnPath"
                              width="20px" height="20px">
                          </span>

                        </ng-container>
                      </ng-container>
                      <ng-template #noUIConfig>
                        <ng-container *ngIf="display_row[column.property] && display_row[column.property].length">
                          <ng-container *ngFor="let item of display_row[column.property] | JSONParser">
                            <ng-container *ngIf="item.enabled ==0 || item.enabled;else default_condition">
                              <span class="mx-1" [matTooltip]="item.notes" [ngClass]="{'table-link':item.enabled}"
                                (click)="item.enabled? checkListItemClicked(display_row,item,column,$event) :''"
                                [innerHTML]="item.icon | safeHTMLPipe :'html' ">
                              </span>
                            </ng-container>
                            <ng-template #default_condition>
                              <span class="" [matTooltip]="item.title" [ngClass]="{'table-link':true}"
                                (click)="checkListItemClicked(display_row,item,column ,$event) "
                                [innerHTML]="item.icon | safeHTMLPipe :'html' ">
                              </span>
                            </ng-template>

                          </ng-container>


                        </ng-container>
                      </ng-template>

                      <!-- [innerHTML]=" ((display_row[column.property])| HTMLFormatter )|safeHTMLPipe :'html'" -->
                    </div>
                  </ng-container>

                </ng-template>

                <ng-template #noDataType>
                  <span (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                    [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])">
                    {{(display_row.processed_data ? display_row.processed_data[column.property] :
                    display_row[column.property])}}
                  </span>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="column.cell_template">
                <div class="column-title"
                  (click)="triggerCellClick(column.function_name, display_row, column,null,$event)"
                  [ngClass]="column.cell_class"
                  [innerHTML]="column.cell_template | HTMLFormatter | safeHTMLPipe :'html'">
                </div>
                <span class="ml-3 float-right" [innerHTML]="column.quick ||  quickTemplate | safeHTMLPipe :'html'"
                  (click)="triggerCellClick(column.function_name, display_row, column,null,$event,1)"
                  *ngIf="column.quick && column.function_name"> <i class="fa fa-tasks"></i> </span>
              </ng-container>

            </ng-container>

            <ng-container *ngIf="column.conditions && column.conditions.length">
              <ng-container
                *ngIf="(display_row && !display_row.loader)||(display_row && display_row.loader && column.property != loader_column_name ) ">
                <div class="column-title"
                  (click)="triggerCellClick(column.function_name, display_row, column ,null,$event)"
                  [ngClass]="column.cell_class"
                  *ngIf="column.cell_template && column.conditions|CheckGridConditions:display_row"
                  [innerHTML]="column.cell_template | HTMLFormatter | safeHTMLPipe :'html'">
                </div>
                <span class="ml-3 float-right" [innerHTML]="column.quick ||  quickTemplate | safeHTMLPipe :'html'"
                  (click)="triggerCellClick(column.function_name, display_row, column,null,$event,1)"
                  *ngIf="column.quick && column.function_name"> <i class="fa fa-tasks"></i> </span>
              </ng-container>
              <ng-container *ngIf="display_row && display_row.loader && column.property == loader_column_name ">
                <div class="column-title" [ngClass]="column.cell_class">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>
              </ng-container>
              <!-- <ng-container *ngIf="display_row && display_row.loader && column.property != loader_column_name ">
                <div class="column-title" [ngClass]="column.cell_class">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>
              </ng-container> -->



            </ng-container>
          </div>
        </td>
      </ng-container>

    </tr>
  </ng-template>
  <ng-template #nested_tr let-row="row" let-i="index">
    <tr>
      <td></td>
      <td colspan="11"
        [style.height.px]="(row.table_object.table_records  && row.table_object.table_records.length) ? (row.table_object.table_records.length > 9 ? '400' : (row.table_object.table_records.length * 24) + 55): ('150')">
        <app-tallint-table [table_records]="row.table_object.table_records||[]" [multi_select]="multi_select"
          [edit]="edit" (cellClicked)="childClick($event)" [total_count]="row.table_object.count || 0"
          [table_columns]="row.table_object.grid" [nested]="nested_nested">
        </app-tallint-table>
      </td>
    </tr>
  </ng-template>


  <ng-template #tr_fixed let-display_row="row" let-i="index">
    <tr *ngIf="i == 0">
      <td class="tallint-td pointer " *ngIf="nested==true" (click)="cellClick('display', display_row)">
        <i class="fa" *ngIf="display_row.child==1"
          [ngClass]="{'fa-minus-square': display_row.nested_flag ,'fa-plus-square': !display_row.nested_flag}">
        </i>
      </td>
      <!-- <td class="tallint-td" [style]="style" *ngIf="nested==true" (click)="cellClick('openEntityTab', display_row)">
  <a class="btn btn-success btn-sm">View</a>
</td> -->
      <td class="p-0 pl-2 pr-2 text-center" *ngIf="multi_select">

        <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-square-o pointer" type="checkbox"
          (click)="rowSelected(display_row)" *ngIf="!display_row['row_selected']"></i>
        <i style="color:#196ca5 !important;font-size:16px;" class="fa fa-check-square-o pointer"
          (click)="rowSelected(display_row)" *ngIf="display_row['row_selected']"></i>
      </td>
      <td class="p-0 pl-2 pr-2 text-center  " style="padding:0 !important;" *ngIf="enable_action">
        <ng-container *ngIf="primary_actions && this.primary_actions.length">
          <i style="color:#196ca5 !important;font-size:16px;" [title]="btn.title | translate"
            (click)="triggerCellClick(btn.func,display_row,null,btn,$event)" *ngFor="let btn of this.primary_actions"
            class="fa {{btn.icon}} pointer mt-1 mx-2"></i>
        </ng-container>
        <i style="color:#196ca5 !important;font-size:16px;" [matMenuTriggerFor]="menu"
          class="fa fa-ellipsis-v pointer mt-1 mx-2 mr-3"></i>
      </td>
      <mat-menu #menu="matMenu">
        <ng-container *ngFor="let action of secondary_actions">
          <button mat-menu-item style="outline: none !important;"
            *ngIf="action.condition | DynamicConditionEval : display_row "
            (click)="triggerCellClick(action.func,display_row,null,action,$event)">
            <i style="font-size: 13px;" class="mr-1" [ngClass]="action.icon" *ngIf="action.show_icon"></i>
            <span> {{action.title | translate}} </span>
          </button>
        </ng-container>

      </mat-menu>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <mat-icon>dialpad</mat-icon>
          <span>Redial</span>
        </button>
        <button mat-menu-item disabled>
          <mat-icon>voicemail</mat-icon>
          <span>Check voice mail</span>
        </button>
        <button mat-menu-item>
          <mat-icon>notifications_off</mat-icon>
          <span>Disable alerts</span>
        </button>
      </mat-menu>

      <td class=" tallint-td my-auto" (click)="triggerCellClick('edit', display_row)" *ngIf="edit">
        <div class="text-center" style="width: 30px;">
          <i class="fa fa-pencil pointer"></i>
        </div>
      </td>
      <!--'font-weight-bold': nested==true && display_row.child==0-->
      <ng-container *ngFor="let column of tallint_table_columns; let index=index;">
        <td *ngIf="column.visible != false" (click)="triggerCellClick(column.function_name, display_row, column)"
          class="tallint-td"
          [ngClass]="{'text-right':column.dataType=='int','pointer table-link':column.function_name && column.function_name!=''}"
          [ngStyle]="{'color': (column.function_name && column.function_name!='') ? '#0056b3' : ''}">
          <div [ngStyle]="{'width': column.width > 10 ? column.width+'px' : '100px'}"
            [ngClass]="{'text-right right-me-lelo':column.dataType=='int'}">
            <ng-container *ngIf="!(column.conditions && column.conditions.length)">
              <ng-container *ngIf="!column.cell_template">
                <ng-container *ngIf="column.dataType ==='date'">
                  <span
                    [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])| LocalDatePipe">
                    {{(display_row.processed_data ? display_row.processed_data[column.property] :
                    display_row[column.property])| LocalDatePipe}}
                  </span>
                </ng-container>
                <ng-container *ngIf="column.dataType ==='datetime'">
                  <span
                    [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property]) | UtcToLocalTime | date: 'h:mm a'">
                    {{(display_row.processed_data ? display_row.processed_data[column.property] :
                    display_row[column.property]) | LocalDateTimePipe}}
                  </span>
                </ng-container>

                <ng-container *ngIf="column.dataType =='nvarchar'">

                  <span class="margin">
                    <span
                      [innerHTML]='(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property]) | HTMLFormatter | safeHTMLPipe :"html"'>
                    </span>
                  </span>
                </ng-container>

                <ng-container *ngIf="column.dataType =='string'">

                  <span class="margin">
                    <span
                      [innerHTML]='(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property]) | HTMLFormatter | safeHTMLPipe :"html"'>
                    </span>
                  </span>
                </ng-container>

                <ng-container *ngIf="column.dataType =='varbinary'">
                  <span
                    [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property]) | DynamicFilesTitlePipe">
                    {{(display_row.processed_data ? display_row.processed_data[column.property] :
                    display_row[column.property]) | DynamicFilesTitlePipe}}
                  </span>
                </ng-container>

                <ng-container
                  *ngIf="column.dataType !='date' && column.dataType !='datetime' && column.dataType !='nvarchar' && column.dataType !='varbinary' && column.dataType !='string' && column.dataType !='innerHTML' ">
                  <span
                    [title]="(display_row.processed_data ? display_row.processed_data[column.property] : display_row[column.property])">
                    {{(display_row.processed_data ? display_row.processed_data[column.property] :
                    display_row[column.property])}}
                  </span>
                </ng-container>

                <!-- For Checklist item view -->
                <ng-container *ngIf="column.dataType =='innerHTML'">
                  <div class="margin">
                    <ng-container *ngIf="display_row[column.property] && display_row[column.property].length">
                      <span class="mx-1" *ngFor="let item of display_row[column.property] | JSONParser"
                        [matTooltip]="item.notes" [ngClass]="{'table-link':item.enabled}"
                        (click)="item.enabled? checkListItemClicked(display_row,item,column,$event) :''"
                        [innerHTML]="item.icon | safeHTMLPipe :'html' ">
                      </span>
                    </ng-container>
                    <!-- [innerHTML]=" ((display_row[column.property])| HTMLFormatter )|safeHTMLPipe :'html'" -->
                  </div>
                </ng-container>
              </ng-container>
              <div [ngClass]="column.cell_class" *ngIf="column.cell_template"
                [innerHTML]="(column.cell_template | HTMLFormatter) | safeHTMLPipe:'html'  ">
              </div>
            </ng-container>

            <ng-container *ngIf="column.conditions && column.conditions.length">
              <div [ngClass]="column.cell_class"
                *ngIf="column.cell_template && column.conditions|CheckGridConditions:display_row"
                [innerHTML]="(column.cell_template | HTMLFormatter)| safeHTMLPipe:'html'">

              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>
    </tr>
  </ng-template>
</div>
